import { setCookie, getCookie } from '../helpers/utilities.js';

const closePopupsButtonWatcher = () => {
	//Close popup
	const closePopupLinksOnPage = document.querySelectorAll('.js-close-popups, .ig-dmn__close');


	if (closePopupLinksOnPage.length > 0) {
		//Check if there are any links first
		closePopupLinksOnPage.forEach(closePopupLink => {
			//Loop through each and give it a onclick event listener
			closePopupLink.addEventListener('click', event => {
				event.preventDefault(); //Stop the link firing normally !
				// Pause all video elements
				const videoElements = document.querySelectorAll('.popup video');
				if (videoElements.length > 0) {
					videoElements.forEach(videoElement => {
						videoElement.pause();
						videoElement.muted = true;
					});
				}

				closeAllPopups();

				document.querySelector('body').classList.remove('js-popup-active');
				document.querySelector('body').dataset.popup = '';
				document.querySelector('body').dataset.popupType = '';
				document.querySelector('body').dataset.popupStyle = '';
			});
		});
	}

	//Close popup on esc key press
	document.addEventListener('keyup', event => {
		if (event.key === 'Escape') {
			if (document.querySelector('.popup.active')) {
				// Pause all video elements
				const videoElements = document.querySelectorAll('.popup video');
				if (videoElements.length > 0) {
					videoElements.forEach(videoElement => {
						videoElement.pause();
						videoElement.muted = true;
					});
				}

				closeAllPopups();

				closePopup();
			}
		}
	});

	// Close main nav popup if screen size goes above 992px
	mobileOnlyPopupCloseWatcher();

	window.addEventListener('resize', mobileOnlyPopupCloseWatcher);
};

function mobileOnlyPopupCloseWatcher() {
	if (window.innerWidth >= 992) {
		// Close main nav popup
		closePopup('#main-nav');
	}
}

const setPopupOpenState = (popup, isOpen) => {
	popup.classList.toggle('active', isOpen);
	popup.toggleAttribute('inert', !isOpen);
	popup.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
};

export const closePopup = (popupId = null) => {
	if (popupId) {
		const popup = document.querySelector(popupId);

		if (popup) {
			setPopupOpenState(popup, false);
		}
	}

	document.querySelector('body').classList.remove('js-popup-active');
	document.querySelector('body').dataset.popup = '';
	document.querySelector('body').dataset.popupType = '';
	document.querySelector('body').dataset.popupStyle = '';
};

export const openPopup = targetPopupID => {
	var targetPopup = document.querySelector(targetPopupID); //Select the popup
	if (targetPopup) {
		//Check we have a valid target popup
		if (targetPopupID == '#main-nav' && document.querySelector('body').classList.contains('js-popup-active')) {
			//If target popup is the main nav, and there's already a popup active, this is a click on the hamburger so treat it as the close button
			closeAllPopups();
			closePopup();
		} else {
			//Otherwise open the popup as normal
			closeAllPopups(); //Make sure no popups are currently open
			setPopupOpenState(targetPopup, true);
			document.querySelector('body').classList.add('js-popup-active'); //Add class to body to show popup is open
			document.querySelector('body').dataset.popup = targetPopupID;

			let popupType;
			let popupStyle = 'full';

			switch (targetPopupID) {
				case '#main-nav':
					popupType = 'main-nav';
					break;
				case '#newsletter':
					popupType = 'newsletter';
					break;
				case '#reservations':
					popupType = 'reservations';
					break;
				default:
					popupType = 'custom-popup';
					break;
			}

			if (popupType == 'custom-popup') {
				popupStyle = document.querySelector(targetPopupID).classList.contains('custom-popup--narrow')
					? 'narrow'
					: 'full';
			}

			document.querySelector('body').dataset.popupType = popupType;
			document.querySelector('body').dataset.popupStyle = popupStyle;
		}
	} else {
		console.warn('Missing Popup: ' + targetPopupID);
	}
};

const closeAllPopups = () => {
	var openPopups = document.querySelectorAll('.popup.active');
	if (openPopups.length > 0) {
		openPopups.forEach(openPopup => {
			setPopupOpenState(openPopup, false);
		});
	}
};

const triggerCustomPopups = () => {
	//Function to launch any custom popups
	let customPopups = document.querySelectorAll('.popup.custom-popup');

	if (customPopups.length > 0) {
		//Check if there are any links first
		customPopups.forEach(customPopup => {
			let displayType = customPopup.dataset.type,
				displayPages = customPopup.dataset.pages,
				displayPeriod = customPopup.dataset.period,
				currentPageID = document.querySelector('body').dataset.page,
				triggerPopup = false;

			if (displayType != 'trigger') {
				//Ignore if manually triggered
				//First check if the visitor already has the cookie, or if the popup is set to always display
				if (displayPeriod == 0) {
					triggerPopup = true;
				} else {
					let hasCookie = getCookie(customPopup.getAttribute('id'));
					if (hasCookie) {
						//User has cookie, don't show the popup
					} else {
						triggerPopup = true;
					}
				}

				//If we're in the trigger period, check to see if we're on the right page
				if (triggerPopup) {
					//No point continuing if they failed the period check!
					if (displayType == 'all') {
						triggerPopup = true;
					} else if (
						displayType == 'exclude' &&
						!displayPages.includes(currentPageID) &&
						currentPageID != ''
					) {
						triggerPopup = true;
					} else if (
						displayType == 'include' &&
						displayPages.includes(currentPageID) &&
						currentPageID != ''
					) {
						triggerPopup = true;
					} else {
						triggerPopup = false;
					}
				}

				if (triggerPopup) {
					//Show the popup and add a cookie if needed
					openPopup('#' + customPopup.getAttribute('id'));
					if (displayPeriod > 0) {
						setCookie(customPopup.getAttribute('id'), true, displayPeriod);
					}
				}
			}
		});
	}
};

closePopupsButtonWatcher();
triggerCustomPopups();
